export default __webpack_public_path__ + "static/media/mandate.59212666.svg";